<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="rightActions"
          @add="addBaseInfo"
          @exportResource="exportBases"
        />
      </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => item.baseId + index"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <template
          slot="updateTime"
          slot-scope="updateTime"
        >
          {{ moment(updateTime).format('YYYY-MM-DD') }}
        </template>

        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editRecord(record)"
            @check="checkRecord(record)"
            @delete="deleteRecord(record)"
          />
        </span>
      </a-table>
    </div>
    <EditBaseInfo
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :action-type="actionType"
      :loading="confirmLoading"
      @cancel="handleCancel"
      @ok="handleOk"
    />
    <CheckChangeRecords
      :init-data="initRecords"
      :visible="recordsVisible"
      :loading="confirmLoading"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import { queryBase, deleteBase, queryChangeRecords, exportBases } from '@/api/baseInfo.js'
import EditBaseInfo from './EditBaseInfo.vue'
import CheckChangeRecords from './CheckChangeRecords.vue'
import {
  queryBases
} from '@/api/common.js'
import moment from 'moment'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'
// import CustomWrapper from '@/components/Draggable/Draggable.vue'
const columns = [
  {
    title: '基地名称',
    dataIndex: 'baseName',
    key: 'baseName',
    width: '130px'
  },
  {
    title: 'BD',
    dataIndex: 'bdName',
    key: 'bdName',
    width: '130px'
  },
  {
    title: '运营商公司',
    dataIndex: 'operatorCompany',
    key: 'operatorCompany',
    width: '130px'
  },
  {
    title: '基地配比系数',
    dataIndex: 'ratio',
    key: 'ratio',
    width: '150px'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '150px',
    scopedSlots: { customRender: 'actions' }
  }
]

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  }
]
const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '修改记录',
    type: 'link',
    action: 'check',
    apis: ['@baseInfo/Export_Bases']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
const rightActions = [{
  title: '添加基地',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导出',
  type: 'primary',
  ghost: true,
  action: 'exportResource',
  apis: ['@baseInfo/Export_Bases']
}
]
export default {
  components: {
    EditBaseInfo,
    CheckChangeRecords
  },
  data () {
    return {
      headerActions,
      columns,
      dataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      baseOptions: [],
      tableActions,
      rightActions,
      modalVisible: false,
      recordsVisible: false,
      confirmLoading: false,
      initData: null,
      initRecords: null,
      dialogTitle: null,
      form: {
      },
      actionType: '0'
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    moment,
    inputKeydown,
    excelDown,
    filterOption,
    fetchSearchOptions () {
      queryBases().then((data) => {
        this.baseOptions = data
      })
    },
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    // 异步获取数据
    fetchData () {
      this.loading = true
      queryBase({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        baseId: this.form.baseId
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    editRecord (record) {
      this.modalVisible = true
      this.initData = record
      this.dialogTitle = '编辑基地'
      this.actionType = '0'
    },
    addBaseInfo () {
      this.initData = {
        baseName: undefined,
        alias: undefined,
        bdName: undefined,
        operatorCompany: undefined,
        ratio: undefined
      }
      this.modalVisible = true
      this.dialogTitle = '添加基地'
      this.actionType = '1'
    },
    checkRecord (record) {
      queryChangeRecords({
        baseId: record.baseId
      }).then((data) => {
        this.initRecords = data
      })
      this.recordsVisible = true
      this.actionType = '0'
    },
    deleteRecord (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteBase({
            baseId: record.baseId
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
              this.fetchSearchOptions()
            } else {
              this.$message.error('存在关联信息，无法删除!')
            }
          })
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
      this.recordsVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
      this.fetchSearchOptions()
    },
    async exportBases () {
      exportBases({ baseId: this.form.baseId }).then((data) => {
        if (data) {
          this.excelDown(data, '基地信息')
        } else {

        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

// .handler {
//    width: 30px;
//    height: 30px;
//    background: #666666;
//    display: inline-block;
//  }
//  .handler:hover {
//    cursor: all-scroll;
//  }
.drag-up {
  animation: dragup ease 0.1s 1;

  animation-fill-mode: forwards;
}

.drag-down {
  animation: dragdown ease 0.1s 1;

  animation-fill-mode: forwards;
}

@keyframes dragup {
  from {
    margin-top: 10px;
  }

  to {
    margin-top: 50px;
  }
}

@keyframes dragdown {
  from {
    margin-bottom: 10px;

    margin-top: 50px;
  }

  to {
    margin-bottom: 50px;

    margin-top: 10px;
  }
}
</style>
